export default "__VITE_ASSET__tH7PY0zp__"